import type { ReactElement } from "react";

export type ProcessingStatus =
	| "pending"
	| "processing"
	| "completed"
	| "failed";

interface StatusIndicatorProps {
	status: ProcessingStatus;
}

export function StatusIndicator({
	status,
}: StatusIndicatorProps): ReactElement {
	if (status === "pending" || status === "processing") {
		const message =
			status === "pending" ? "Waiting to process..." : "Processing...";
		return (
			<div className="text-accent flex items-center gap-2">
				<span className="bg-accent inline-block h-2 w-2 animate-pulse rounded-full" />
				<span>{message}</span>
			</div>
		);
	}

	if (status === "failed") {
		return (
			<div className="text-red-400">
				Something went wrong while processing.
			</div>
		);
	}

	return (
		<div className="text-accent flex items-center gap-2">
			<span className="material-symbols-outlined text-base">
				check_circle
			</span>
			<span>Extraction complete</span>
		</div>
	);
}
